import React, {useMemo, useState} from 'react';
import {useSelector} from "react-redux";

import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import {DropzoneAreaBase} from "material-ui-dropzone";

import {getProfile} from "../../../redux/reducers/user-profile-reducer";

import {MasterOfActsAPI} from "../../../api/api";
import {downloadActScanFile} from "../../../redux/reducers/act-reducer";

import {Dialog} from "../../Dialog/Dialog";


const MAX_FILE_SIZE = 10000000

const useStyles = makeStyles(() => (
    {
        previewChip: {
            minWidth: 160,
            maxWidth: 210
        }
    }
))

export const UploadActScanDialog = ({open, handleClose, files, creator, handleActScan}) => {
    const classes = useStyles()

    const {user} = useSelector(getProfile)
    const parsedFiles = useMemo(() => files.map(el => ({file: {name: el.filename}, id: el.id})), [files])
    const [localFiles, setLocalFiles] = useState(parsedFiles || [])

    const handleAddLocalFiles = (newFiles) => setLocalFiles([...localFiles, ...newFiles])

    const onDeleteFile = (file) => setLocalFiles(localFiles.filter(f => f.id !== file.id))

    const onAddFile = async (newFiles) => {
        let acceptedFiles = []
        for (const newFile of newFiles) {
            const response = await MasterOfActsAPI.uploadActScan(creator || user.id, newFile.file, newFile.file.name)
            if (response.status === 201) {
                acceptedFiles = [...acceptedFiles, {file: {name: newFile.file.name}, id: response.data.id}]
            }
        }
        handleAddLocalFiles(acceptedFiles)
    }

    const onDownloadFile = async (event) => {
        const filename = event.target.outerText
        const fileId = localFiles.filter(f => f.file.name === filename)[0].id
        await downloadActScanFile(fileId)
    }

    const handleSaveActScans = () => {
        handleActScan(localFiles.map(el => ({filename: el.file.name, id: el.id})))
        handleClose()
    }

    return <Dialog open={open}
                   handleClose={handleClose}
                   title={'Загрузка скана акта'}
                   fullWidth
                   maxWidth={'md'}
                   actions={<Button onClick={handleSaveActScans} variant={"outlined"}>Сохранить</Button>}
    >
        <DropzoneAreaBase
            fileObjects={localFiles}
            maxFileSize={MAX_FILE_SIZE}
            onAdd={onAddFile}
            onDelete={onDeleteFile}
            dropzoneText={'Нажмите на выделенную область или перетащите файлы для загрузки'}
            getFileLimitExceedMessage={(filesLimit) => `Превышено максимально допустимое количество файлов. Разрешено только ${filesLimit} `}
            getFileAddedMessage={(fileName) => `Файл ${fileName} успешно добавлен `}
            getFileRemovedMessage={(fileName) => `Файл ${fileName} удален `}
            getDropRejectMessage={(rejectedFile) => `Файл ${rejectedFile.name} был отклонен `}
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            previewGridProps={{container: {spacing: 1, direction: 'row'}}}
            previewChipProps={
                {
                    classes: {
                        root: classes.previewChip
                    },
                    onClick: onDownloadFile
                }}
            previewText="Загруженные файлы"
        />
    </Dialog>
}
